import React from 'react'
import { connect } from '@cerebral/react'
import { signal } from 'cerebral/tags'
import { t } from '@billes/translator-client'
import { Tags } from 'components/Icons'

export default connect(
  {
    onOpenTagMenu: signal`media.onOpenTagMenu`
  },
  ({ onOpenTagMenu }) => (
    <div
      title={t('bms.media.titles.toggleTagsMenu')}
      onClick={e => onOpenTagMenu()}
    >
      <Tags
        style={{
          cursor: 'pointer',
          height: 36,
          width: 36,
          fill: '#afafaf'
        }}
        viewBox={'-4 0 26 26'}
      />
    </div>
  )
)



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/TagIcon/tagIcon.js